module.exports = __webpack_public_path__ + "img/Finland.1b1e92f5.svg";